import { api, createFormData } from "./api.js"
import qs from "qs"

export const axiosAuthHeaders = async () => {
    let accessToken = null
    if (Cookies.get("_ACCOUNT_TOKEN_")) {
        const tokenType = cookies['_TOKEN_TYPE_'] ? cookies['_TOKEN_TYPE_'] : "bearer";
        accessToken = tokenType + ' ' + Cookies.get("_ACCOUNT_TOKEN_")
    }

    if (accessToken) {
        return {
            Authorization: accessToken,
        };
    } else {
        // 取得購物車token
        // const shopToken = await _api_getShopToken()
        // console.debug("shopToken: ", shopToken)
        return {}
    }
};

/**
 * 取得購物車token
 */
const _api_getShopToken = () => {
    return api({
        url: `carts/shop-token`,
        method: `GET`,
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err.response.data)
    })
}

/**
 * 加入購物車
 * @param {Object} data
 *  @property {Number} store_product_id 賣場商品ID
 *  @property {Number} store_assort_id 賣場商品組合ID
 *  @property {Number} quantity 加入數量
 */
const _api_createCart = (data) => {
    return api({
        url: `carts/set`,
        method: `POST`,
        data: data,
    }).then((res) => {
        return res
    }).catch((err) => {
        return Promise.reject(err.response.data)
    })
}

/**
 * 加入購物車分群
 */
const _api_createCartGroup = (data) => {
    return api({
        url: `carts/set-group`,
        method: `POST`,
        data: data,
    }).then((res) => {
        return res
    }).catch((err) => {
        return Promise.reject(err.response.data)
    })
}

/**
 * 購物車列表
 */
const _api_getCartInfo = () => {
    return api({
        url: `carts/checkout`,
        method: `GET`,
        params: {

        },
    }).then((res) => {
        // console.debug("_api_getCartInfo", res?.headers?.['x-request-id'])
        return { ...res.data, headers: res?.headers }
    }).catch((err) => {
        return err.response.data
    })
}


/**
 * 購物車數量
 */
const _api_getCarts = () => {
    return api({
        url: `carts/count`,
        method: `GET`,
        params: {

        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 更新購物車數內容 (數量)
 */
const _api_updateCartQty = (cartId, quantity, isBundle = false) => {
    console.debug("更新購物車數內容", isBundle)
    return api({
        url: `carts/update`,
        method: `POST`,
        data: {
            cart_id: cartId,
            quantity,
            isBundle,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}


/**
 * 刪除購物車某內容
 */
const _api_deleteCart = (cartId) => {
    return api({
        url: `carts/update`,
        method: `POST`,
        data: {
            cart_id: cartId,
            quantity: 0,
        },
    }).then((res) => {
        return res
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 購物車結帳(Step1)
 */
const _api_checkoutCart = (data) => {
    return api({
        url: `carts/checkout`,
        method: `POST`,
        data: data,
    }).then((res) => {
        return res
    }).catch((err) => {
        return err.response
    })
}

/**
 * 循環購結帳
 */
const _api_periodCheckoutCart = (data) => {
    return api({
        url: `carts/period-checkout`,
        method: `POST`,
        data: data,
    }).then((res) => {
        return res
    }).catch((err) => {
        return err.response
    })
}


/**
 * 711門市
 */
const _api_get711Shops = (data) => {
    return api({
        url: `cvs/711`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 全家門市
 */
const _api_getFamilyShops = (data) => {
    return api({
        url: `cvs/family`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}


/**
 * 萊爾富門市
 */
const _api_getHilifeShops = (data) => {
    return api({
        url: `cvs/hilife`,
        method: `GET`,
        params: {
            ...data,
        },
    })
        .then((res) => {
            return res.data
        })
        .catch((err) => {
            return err.response.data
        })
}


/**
 * OK門市
 */
const _api_getOkmartShops = (data) => {
    return api({
        url: `cvs/okmart`,
        method: `GET`,
        params: {
            ...data,
        },
    })
        .then((res) => {
            return res.data
        })
        .catch((err) => {
            return err.response.data
        })
}

/**
 * 訂單列表
 */
const _api_getOrders = (data) => {
    return api({
        url: `orders`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}


/**
 * 循環購訂單列表
 */
const _api_getPeriodOrders = (data) => {
    return api({
        url: `period-orders`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}


/**
 * 取消訂單
 */
const _api_postCancelOrder = (uuid, data) => {
    return api({
        url: `orders/${uuid}/cancel`,
        method: 'POST',
        data: data,
    })
}

/**
 * 更新訂單收款方式
 */
const _api_putOrderPaymemnt = (uuid, data) => {
    return api({
        url: `orders/${uuid}/payment`,
        method: 'PUT',
        data: data,
    })
}

/**
 * 佣金紀錄列表
 */
const _api_getCoinActivities = (data) => {
    return api({
        url: `coin/activities`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 訂閱紀錄列表
 */
const _api_getSubscriptions = (data) => {
    return api({
        url: `subscriptions`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 新增訂閱
 */
const _api_postSubscription = (data) => {
    return api({
        url: `subscriptions`,
        method: `POST`,
        data: data,
    })
}

/**
 * 編輯會員資料
 */
const _api_patchAuthProfile = (data) => {
    return api({
        url: `auth/profile`,
        method: `PATCH`,
        data: data,
    })
}

/**
 * 常用地址列表
 */
const _api_getAddresses = (data) => {
    return api({
        url: `addresses`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 新增常用地址
 */
const _api_postAddress = (data) => {
    return api({
        url: `addresses`,
        method: `POST`,
        data: data,
    })
}

/**
 * 編輯常用地址
 */
const _api_putAddress = (uads_id, data) => {
    return api({
        url: `addresses/${uads_id}`,
        method: `PUT`,
        data: data,
    })
}

/**
 * 刪除常用地址
 */
const _api_deleteAddress = (uads_id) => {
    return api({
        url: `addresses/${uads_id}`,
        method: `DELETE`,
    })
}

/**
 * 預設常用常用地址
 */
const _api_setDefaultAddress = (uads_id) => {
    return api({
        url: `addresses/${uads_id}/set-default`,
        method: `POST`,
    })
}

/**
 * 商品列表
 */
const _api_getProducts = (params) => {
    return api({
        url: `products`,
        method: `GET`,
        params,
        paramsSerializer: function (params = {}) {
            const queryParams = {}
            for (const key in params) {
                if (params[key] !== null) {
                    queryParams[key] = params[key]
                }
            }
            return qs.stringify(queryParams, { arrayFormat: "repeat" })
        },
    }).then((res) => {
        return { ...res.data, headers: res.headers }
    }).catch((err) => {
        return Promise.reject(err.response.data)
    })
}

/**
 * 商品詳情
 */
const _api_getProduct = (id, params = {}) => {
    return api({
        url: `products/${id}`,
        method: `GET`,
    }).then((res) => {
        return { ...res.data, headers: res.headers }
    }).catch((err) => {
        return Promise.reject(err.response.data)
    })
}

/**
 * 促銷列表
 */
const _api_getPromotions = (params) => {
    const request = {
        params,
        paramsSerializer: function (params = {}) {
            const queryParams = {}
            for (const key in params) {
                if (params[key] !== null) {
                    queryParams[key] = params[key]
                }
            }
            return qs.stringify(queryParams, { arrayFormat: "repeat" })
        },
    }

    return api({
        url: `promotions`,
        method: `GET`,
        ...request,
    }).then((res) => {
        return { ...res.data, headers: res.headers }
    }).catch((err) => {
        return Promise.reject(err.response.data)
    })
}
/**
 * 活動詳情
 */
const _api_getPromotionInfo = async (id, params) => {
    return api({
        url: `promotions/${id}`,
        method: `GET`,
        params,
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return Promise.reject(err.response.data)
    })
}

/**
 * 促銷商品列表
 */
const _api_getPromotionProducts = (id, data) => {
    return api({
        url: `promotions/${id}/products`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 文章列表
 */
const _api_getArticles = (data) => {
    return api({
        url: `articles`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return res.data
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 貼文列表
 */
const _api_getPosts = (data) => {
    return api({
        url: `posts`,
        method: `GET`,
        params: {
            ...data,
        },
    }).then((res) => {
        return { ...res.data, headers: res.headers }
    }).catch((err) => {
        return err.response.data
    })
}

/**
 * 退款帳戶列表
 */
const _api_getAccountRefunds = (data) => {
    return api({
        url: `refund-accounts`,
        method: `GET`,
        params: {
            ...data,
        },
    })
}

/**
 * 新增退款帳戶
 */
const _api_postAccountRefund = (payload) => {
    const data = createFormData(payload)
    return api({
        url: `refund-accounts`,
        method: `POST`,
        data: data,
    })
}

/**
 * 退款帳戶詳情
 */
const _api_getAccountRefund = (account_id, data) => {
    return api({
        url: `refund-accounts/${account_id}`,
        method: `GET`,
        params: {
            ...data,
        },
    })
}

/**
 * 編輯退款帳戶
 */
const _api_putAccountRefund = (account_id, payload) => {
    const data = createFormData(payload)
    return api({
        url: `refund-accounts/${account_id}`,
        method: `PUT`,
        data: data,
    })
}

/**
 * 台灣銀行列表
 */
const _api_getTwBanks = (data) => {
    return api({
        url: `data/tw-banks`,
        method: `GET`,
        params: {
            ...data,
        },
    })
}

/**
 * 會員促銷折扣碼列表
 */
const _api_getAccountPromotionCodes = (data) => {
    return api({
        url: `account/promotion-codes`,
        method: `GET`,
        params: {
            ...data,
        },
    })
}
/**
 * 領取會員促銷折扣碼
 */
const _api_postAccountPromotionCodes = (data) => {
    return api({
        url: `account/promotion-codes`,
        method: `POST`,
        data: data,
    })
}

/**
 * 國家縣市資料包
 */
const _api_getCountryMap = async (country = 'TW') => {
    const country_code = country.toLowerCase();
    return api({
        url: `data/iso-3166-ext/${country_code}`,
        method: `GET`,
    });
};

export {
    _api_getShopToken,
    _api_createCart,
    _api_createCartGroup,
    _api_getCarts,
    _api_getCartInfo,
    _api_updateCartQty,
    _api_deleteCart,
    _api_checkoutCart,
    _api_periodCheckoutCart,
    _api_get711Shops,
    _api_getFamilyShops,
    _api_getHilifeShops,
    _api_getOkmartShops,
    _api_getOrders,
    _api_getPeriodOrders,
    _api_postCancelOrder,
    _api_putOrderPaymemnt,
    _api_getCoinActivities,
    _api_getSubscriptions,
    _api_postSubscription,
    _api_patchAuthProfile,
    _api_getAddresses,
    _api_postAddress,
    _api_putAddress,
    _api_deleteAddress,
    _api_setDefaultAddress,
    _api_getProducts,
    _api_getProduct,
    _api_getPromotions,
    _api_getPromotionInfo,
    _api_getPromotionProducts,
    _api_getArticles,
    _api_getPosts,
    _api_getAccountRefunds,
    _api_postAccountRefund,
    _api_getAccountRefund,
    _api_putAccountRefund,
    _api_getTwBanks,
    _api_getAccountPromotionCodes,
    _api_postAccountPromotionCodes,
    _api_getCountryMap,
}
